<template>
  <div v-loading="isInit">
    <div>
      <el-select @change="search()" placeholder="人员" v-model="personnelId" size="medium" filterable>
        <el-option v-for="item in personnelList" :key="item.PersonnelId" :label="item.FullName"
          :value="item.PersonnelId"></el-option>
      </el-select>
    </div>
    <pagination v-loading="loading" :data="listData" :option="paginationOption"></pagination>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import pagination from "../common/pagination";

import {
  getPersonnelHistoryList,
  getPersonnels
} from "@/service/oganization.service";

export default {
  props: {
  },
  data() {
    return {
      isInit: false,
      loading: false,
      listData: {},
      paginationOption: {},
      personnelList: [],
      personnelId: "",
      searchKeyword: "",
      pageSize: 20,
    };
  },
  components: {
    pagination,
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      fnSpanMethod: this.spanMethod
    };
    this.isInit = true;
    getPersonnels(false).then(result => {
      if (!!result && result.success) {
        this.personnelList = result.data;
      }
      this.isInit = false;

    });
  },
  methods: {
    search() {
      let pageData = this.getSearchPageData();
      this.loading = true;
      getPersonnelHistoryList(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getSearchPageData() {
      let pageData = {
        pageNumber: 1,
      };
      let additionalFilter = {
        personnelId: this.personnelId
      };

      let searchData = {
        pageSize: this.pageSize,
        keyWord: "",
        additionalFilter: additionalFilter,
      };

      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    spanMethod({ row, column, rowIndex, columnIndex }){
      if (this.listData){
        let count = this.listData.Results.length;
        if (count > 1){
          switch(column.columnKey){
            case "FullName":
            case "Phone":
            case "Comment":
            case "InterviewRecordingId":
            case "ResumeFileId": {
              if (rowIndex== 0){
                return {
                  rowspan: count,
                  colspan: 1
                };
              }else{
                return {
                  rowspan: 0,
                  colspan: 0
                };
              }
              
            }
          }
        }
      }
    
      return {
        rowspan: 1,
        colspan: 1
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/orgChart/personnelHistoryList.vue